import { Component, Input, OnInit, Output } from '@angular/core';
import { ExemploJestService } from './exemplo-jest.service';

@Component({
  selector: 'app-exemplo-jest',
  templateUrl: './exemplo-jest.component.html',
})
export class ExemploJestComponent implements OnInit {
  @Input() resultado: number = 0;

  primeiroNumero: number = 0;
  segundoNumero: number = 0;

  constructor(private exemploJestService: ExemploJestService) {}

  somarNumeros() {
    this.resultado = this.exemploJestService.somaDoisNumeros(
      this.primeiroNumero,
      this.segundoNumero
    );
  }

  ngOnInit(): void {}
}
